<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { ICompanyInvoiceEmail } from "../../entities";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import Button from "../../components/Button.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";

  export let emails: ICompanyInvoiceEmail[] = [];
  export let entityId: number = 0;
  export let disabled: boolean = false;

  let ownOid = 0;
  let ownOidToAdd = 0;

  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

  function onEdit(own: ICompanyInvoiceEmail) {
    ownOid = own.oid;
  }

  function onSave() {
    let owner = {
      oid: ownOid,
      entityId: entityId,
      ownership: {oid: ownOidToAdd} as IOwnership
    } as ICompanyInvoiceEmail;
    dispatch("save", owner);
    ownOid = 0;
    ownOidToAdd = 0;
  }

  function onDelete(owner: ICompanyInvoiceEmail) {
    dispatch("delete", owner);
  }

  onMount(() => onLoad());
</script>

<div class="box">
  <h1 class="subtitle">Email inviate</h1>
  {#if !disabled}
  <FormField>
  <div class="columns">
    <div class="column is-5">
      <Button on:click={onSave} {disabled} >Invia fattura</Button>
    </div>
  </FormField>
  {/if}

  {#each emails as email}
    <hr class="comment-separator" />
    <div class="comment-info">

      {#if email.createdBy != "" && email.createdBy != null}
        {formatTimestampHuman(email.createdOn)} - {email.createdBy}
      {:else}
        {formatTimestampHuman(email.createdOn)}
      {/if}
    </div>
    <div class="content">
    {#if email.risultato == 'OK'}
      <p class="subtitle is-size-6 has-text-success">OK</p>
    {:else}
      <p class="subtitle is-size-6 has-text-danger">
      {#if email.diagnostico != "" && email.diagnostico != null}
        {email.risultato}- {email.diagnostico}
      {:else}
        {email.risultato}
      {/if} 
      </p>
    {/if}


    </div>
  {/each}
</div>

<style>
  .comment-separator {
    margin: 4px 0;
  }
  .comment-info {
    position: relative;
  }
  .comment-info-text {
    color: #999;
    font-size: x-small;
    display: inline-block;
    position: absolute;
    top: 4px;
    margin-left: 5px;
  }
</style>
